import React, { Component, Fragment } from 'react'
import Breadcrumb from '../../common/breadcrumb';
// import data from '../../../assets/data/pro_list';
import Datatable_product from '../../common/datatable_product'
import CSVReader from 'react-csv-reader'

 
export class Digital_pro_list extends Component {

    constructor(props){
        super(props);
   
        this.state = {
            open:true,
            product:[]
       };
    }

    componentDidMount()
    {
        if(!localStorage.getItem('userInfo')){
            window.location.href='/admin';
        }

        fetch(`${process.env['REACT_APP_HOST']}/api/products/mobile`)
        .then((response) => response.json())
        .then(result=>{
            this.setState({product:result.productList});
            
        });
    }

    deleteHandler = (id) => {
        if (window.confirm('Are you sure')) {
            const url = `${process.env['REACT_APP_HOST']}/api/products/${id}`;
		    const params = {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
			}
		};
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                // console.log(data)
                // window.location.reload(); 
            })
        }
    }

    readFile(data, fileInfo){
        const products = [];

        for (let i = 1; i < data.length; i++) {
            const j = i;
            products.push({
                name               : data[j][0],
                price              : data[j][1],
                offerPrice         : data[j][2],
                category           : data[j][3],
                shortDescription   : data[j][4],
                gameVersion        : data[j][5],
                description        : data[j][6],
                image              : data[j][7],
                image1             : data[j][8],
                image2             : data[j][9],
                image3             : data[j][10],
                zip                : data[j][11],
                mobilePlatform     : data[j][12],
                desktopPlatform    : data[j][13],
                vrPlatform         : data[j][14],
                threeSixtyPlatform : data[j][15],
                learningOutcomes   : data[j][16],
                requirements       : data[j][17],
                duration           : data[j][18],
                modulesNo          : data[j][19]
            });

            const url = `${process.env['REACT_APP_HOST']}/api/products/`;
            const params = {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name                : data[j][0],
                    price               : data[j][1],
                    offerPrice          : data[j][2],
                    category            : data[j][3],
                    shortDescription    : data[j][4],
                    gameVersion         : data[j][5],
                    description         : data[j][6],
                    image               : data[j][7],
                    image1              : data[j][8],
                    image2              : data[j][9],
                    image3              : data[j][10],
                    zip                 : data[j][11],
                    mobilePlatform      : data[j][12],
                    desktopPlatform     : data[j][13],
                    vrPlatform          : data[j][14],
                    threeSixtyPlatform  : data[j][15],
                    learningOutcomes    : data[j][16],
                    requirements        : data[j][17],
                    duration            : data[j][18],
                    modulesNo           : data[j][19]
                }),
            };
            fetch(url, params)
              .then(response => response.json())
              .then(result => {
                //   console.log(result)
                  // window.location.reload(); 
                //   toast.success("Successfully Added !")
              })
        }
        // console.log(products)
    }

    render() {
       
        return ( 
            <Fragment>
                <Breadcrumb title="Product List" parent="Digital" />
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                {/* <div className="card-header">
                                    <h5>Product Lists</h5>
                                    <CSVReader onFileLoaded={this.readFile} />
                                </div> */}
                                <div className="card-body">
                                    <div className="clearfix"></div>
                                    <div id="basicScenario" className="product-physical">
                                        <Datatable_product
                                            multiSelectOption={false}
                                            myData={this.state.product}
                                            pageSize={10}
                                            pagination={true}
                                            class="-striped -highlight"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
            </Fragment>
        )
    }
}

export default Digital_pro_list
